import React from 'react';
import type { UnifiedTask } from '@/types/tasks';
import type { User } from '@/types/user';
import type { CustomerUI } from '@/types/ui/customers';
import type { UpdateTaskApiRequest } from '@/types/api/tasks';
import { TaskDetailsDrawer } from '@/components/tasks/task-details-drawer';

interface TaskDrawerRouterProps {
  task: UnifiedTask | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  users?: User[];
  customers?: CustomerUI[];
  onSave?: (taskId: string, data: UpdateTaskApiRequest) => void;
  onComplete?: (taskId: string) => void;
}

/**
 * Smart Task Drawer Router
 * 
 * Shows task details with source record summary.
 * Users can navigate to the full source record for editing.
 */
export const TaskDrawerRouter: React.FC<TaskDrawerRouterProps> = ({
  task,
  open,
  onOpenChange,
  users,
  customers,
  onSave,
  onComplete,
}) => {
  if (!task) {
    return null;
  }

  return (
    <TaskDetailsDrawer
      task={task}
      open={open}
      onOpenChange={onOpenChange}
      users={users}
      customers={customers}
      onSave={onSave}
      onComplete={onComplete}
    />
  );
};
